import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icons/Cloud_0.png'
import _imports_1 from '@/assets/images/icons/Cloud_1.png'
import _imports_2 from '@/assets/images/static/TitleRule.png'
import _imports_3 from '@/assets/images/static/Cards.png'


const _hoisted_1 = { class: "global-wrapper invoice-rule-wrapper" }
const _hoisted_2 = { class: "global-container invoice-rule-container" }
const _hoisted_3 = { class: "invoice-rule" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "invoice-rule__Cloud-0",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "invoice-rule__Cloud-1",
  src: _imports_1
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "title",
  src: _imports_2
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "cards",
  src: _imports_3
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createVNode("div", {
          class: "content",
          innerHTML: _ctx.content
        }, null, 8, ["innerHTML"])
      ])
    ])
  ]))
}